import React, {useState, useEffect} from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useStateMachine } from "little-state-machine";
import updateAction from "./updateAction";
import CSVParser from './csvparser';
// import CustomTable from './table';
// import ReactTable from "react-table";
import ReactCustomTable from './reactTable';
// import ReactTooltip from "react-tooltip";
import Select from "react-select";
import { Modal, Button, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import faker from "faker";

import { CSVLink } from "react-csv";
// import {Tab, Tabs} from 'react-bootstrap';


faker.seed(123);

const createRandomData = (dataLength) => {
  const randomData = [];
  for (let i = 0; i < dataLength; i++) {
    var dos = faker.date.past(10);
    dos = dos.getFullYear() + "-" + ("0" + (dos.getMonth()+1)).slice(-2) + "-" + ("0" + dos.getDate()).slice(-2);
    randomData.push({
      City: faker.address.cityName(),
      Customer_ID: faker.datatype.number(500),
      // Email: faker.datatype.number(10)>2 ? faker.internet.email() : 0,
      Email: faker.datatype.number(10)>2 ? 1 : 0,
      Industry: faker.name.jobArea(),
      Order_Date: dos,
      Order_ID: faker.datatype.number(),
      Sales: parseInt(faker.finance.amount(15,899,0), 0),
    });
  }
  return randomData
}

const Step2 = props => {
  const [ isLoading, setLoading ]  = useState(true);
  const { state, action } = useStateMachine(updateAction);
  const { handleSubmit, control, errors } = useForm({
    defaultValues: state.yourDetails
  });
  const { push } = useHistory();

  const onSubmit = data => {
    action(data);
    push("/result");
  };
  
  useEffect(() => {
    createTableData();
    // setLoading(false);
  }, [])

  const createTableData = async () => {
    action({
        csvTable: await createRandomData(150),
        csvTable_final: [],
        csvTableErrors: [],
        csvTableMeta: [],
        csvTableSelectedCol_Order_Date: {value: 1, label: "Order_Date"},
        csvTableSelectedCol_Order_ID: {value: 1, label: "Order_ID"},
        csvTableSelectedCol_Sales: {value: 1, label: "Sales"},
        csvTableSelectedCol_Customer_ID: {value: 1, label: "Customer_ID"},
        csvTableSelectedCol_City: {value: 1, label: "City"},
        csvTableSelectedCol_Industry: {value: 1, label: "Industry"},
        csvTableSelectedCol_Email: {value: 1, label: "Email"},
    })
    setLoading(false);
  }


  const handleOnRemoveFile = () => {
    action({
      csvTable: [],
      csvTable_final: [],
      csvTableErrors: [],
      csvTableMeta: [],
      csvTableSelectedCol_Order_Date: "",
      csvTableSelectedCol_Order_ID: "",
      csvTableSelectedCol_Sales: "",
      csvTableSelectedCol_Customer_ID: "",
      csvTableSelectedCol_City: "",
      csvTableSelectedCol_Industry: "",
      csvTableSelectedCol_Email: "",
      userUploadShow: true,
      showTable: false,
      ShowTable_final: false
    })
  }

  // Styling for select
  const selectStyles = {
    control: styles => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { isFocused }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? '#ec5990':'white',
        color: 'black',
      };
    }
  };
  
  const [userUploadShow, setUserUploadShow] = useState(false);


  const [modalShow, setModalShow] = useState(false);
  const MyVerticallyCenteredModal = (props) => {
    return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Upload a CSV file
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Step 1: Create a CSV file using Excel</h4>
          <ul>
            <li>Make sure your data has a header</li>
            <img width="100%" src={require('../img/csv1.png')} alt="Data must have a Header"></img>
            <li>The data must has 6 columns:</li>
              <ul>
                <li>Customer_ID</li>
                <li>Order_Date: in "YYYY-MM-DD" format</li> 
                <li>Order_ID</li>
                <li>Sales: any number</li>
                <li>City</li>
                <li>Industry</li>
                <li>Email</li>
              </ul>
            <li>Go to <b>File / Save as...</b> then chose <b>CSV</b> as the <b>File Format</b></li>
            <img width="100%" src={require('../img/csv2.png')} alt="Choose CSV as File Format"></img>
          </ul>

        <h4>Step 2: Upload the CSV file </h4>

          <ul>
              <li>Drop the CSV file in the box as instructed or click the box to upload.</li>
              <img width="100%" src={require('../img/uploadCSV.png')} alt="Upload CSV"></img>
          </ul>

      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
    );
  }

  if (isLoading) {
    return (
      <>
        <h1>loading</h1>
      </>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h1>How It Works</h1>
      <span style={{color: "#44BEA8"}}>
        To get started, you can either upload your own data, or we can generate automated data for you!
        <br></br>
      </span>
      {/* <Button variant="info" onClick={() => {setUserUploadShow(true); handleOnRemoveFile()}}>
        Upload my own data
      </Button>
      <Button variant="info" onClick={() => {setUserUploadShow(false); createTableData()}}>
        Generate Data for me
      </Button> */}

      <ToggleButtonGroup type="checkbox" value={userUploadShow} className="mb-2">
        <ToggleButton value={true} onChange={() => { setUserUploadShow(true); handleOnRemoveFile()}}>
          Upload my own data
        </ToggleButton>
        <ToggleButton value={false} onChange={() => { setUserUploadShow(false); createTableData()}}>
          Generate Data for me
        </ToggleButton>
      </ToggleButtonGroup>

      {!userUploadShow && (
        <>
          <h3>Generate Data for me</h3>

          <Button variant="success" onClick={() => {createTableData()}}>
            Regenerate Data
          </Button>
          {/* <CustomTable data={state.yourDetails.csvTable.slice(0, 5) }/> */}

          {/* <button type="">       
            <CSVLink 
              data={state.yourDetails.csvTable}
              filename={"AAARL-demo.csv"}
              className="btn"
            >
              Download Result
            </CSVLink>
          </button> */}

          <ReactCustomTable data={ state.yourDetails.csvTable }/>

          <input type="submit" value="Next"/>
        </>
      )}




      {userUploadShow && (
        <>
          <h3>Upload my own data</h3>
          <Button variant="primary" onClick={() => setModalShow(true)}>
            Instructions
          </Button>
          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
          <div>
            {!state.yourDetails.showTable && (
              <CSVParser />
            )}
            {state.yourDetails.showTable && (
              <>
                <button type="clear" onClick={handleOnRemoveFile}>Clear CSV</button>
                <label>
                  Select Order Date Column:
                  <Controller
                    name="csvTableSelectedCol_Order_Date"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_Order_Date && <p>This is required.</p>}
                </label>
                <label>
                  Select Order ID Column:
                  <Controller
                    name="csvTableSelectedCol_Order_ID"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_Order_ID && <p>This is required.</p>}
                </label>
                <label>
                  Select Sales Column:
                  <Controller
                    name="csvTableSelectedCol_Sales"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_Sales && <p>This is required.</p>}
                </label>


                <label>
                  Select Customer ID Column:
                  <Controller
                    name="csvTableSelectedCol_Customer_ID"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_Customer_ID && <p>This is required.</p>}
                </label>
                <label>
                  Select City Column:
                  <Controller
                    name="csvTableSelectedCol_City"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_City && <p>This is required.</p>}
                </label>
                <label>
                  Select Industry Column:
                  <Controller
                    name="csvTableSelectedCol_Industry"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_Industry && <p>This is required.</p>}
                </label>
                <label>
                  Select Email Column:
                  <Controller
                    name="csvTableSelectedCol_Email"
                    as={Select}
                    options={state.yourDetails.colOptions.map((key, index) => {
                      return {value: index+1, label: key }
                    })}
                    control={control}
                    styles={selectStyles}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.csvTableSelectedCol_Email && <p>This is required.</p>}
                </label>

                {/* <CustomTable data={state.yourDetails.csvTable.slice(0, 5) }/> */}
                {state.yourDetails.csvTable  && (
                  <ReactCustomTable data={ state.yourDetails.csvTable }/>
                )}
                <input type="submit" value="Next"/>
              </>
            )}
          </div>
        </>
      )}

    </form>
  );
};

export default Step2;
